var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlertIcon = function SvgAlertIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "alert_icon_svg__alert_icon",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.75 7L10.6094 12H9.38477L9.25 7H10.75ZM10.7391 14.7165C10.5652 14.9055 10.3188 15 10 15C9.68116 15 9.43478 14.9055 9.26087 14.7165C9.08696 14.5275 9 14.2925 9 14.0115C9 13.7203 9.08937 13.4789 9.26812 13.2874C9.44686 13.0958 9.69082 13 10 13C10.3092 13 10.5531 13.0958 10.7319 13.2874C10.9106 13.4789 11 13.7203 11 14.0115C11 14.2925 10.913 14.5275 10.7391 14.7165Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 3.4707L2.41474 16.7H17.5853L10 3.4707ZM10.9829 2.57143C10.5461 1.80952 9.45393 1.80952 9.01708 2.57143L1.15375 16.2857C0.716899 17.0476 1.26296 18 2.13667 18H17.8633C18.737 18 19.2831 17.0476 18.8462 16.2857L10.9829 2.57143Z",
    fill: "currentColor"
  })));
};
export default SvgAlertIcon;